// 1. 基础映射配置（保持不变，仅格式化）
export const reportTypeMap = {
  '0': '帖子举报',
  '1': '帖子申诉',
  '2': '圈子投诉',
  '3': '管理投诉',
  '4': '用户举报',
  '5': '评论举报',
  '6': '回复评论举报'
};

export const rankTypeMap = {
  'post': '内容排行',
  'points': '积分排行榜',
  'balance': '贝壳排行榜',
  'gift': '送礼物排行榜',
  'receiveGift': '收礼物排行榜',
  'invitation': '邀请排行榜'
};

// 2. 公共配置抽离
const COMMON_HOME = { path: '/home', name: '首页' };

// 模块基础路径配置
const MODULE_MAP = {
  USER_INFO: { path: '/userHome', name: '用户信息' },
  SQUARE_MANAGE: { path: '/square', name: '广场管理' },
  ENTERTAINMENT: { path: '/entertainment', name: '娱乐系统' }, // 统一模块名
  POST_MANAGE: { path: '/content', name: '帖子管理' },
  REPORT_MANAGE: { path: '/cardReport', name: '举报管理' },
  WALLET_MANAGE: { path: '/walletManage', name: '钱包管理' }, // 统一模块路径
  USER_SERVICE: { path: '/userService', name: '用户服务' }, // 统一模块路径
  PERSONAL_CENTER: { path: '/personalCenter', name: '个人中心' }
};

// 3. 工具函数：生成面包屑数组
const generateBreadcrumb = (segments) => [COMMON_HOME, ...segments];

// 4. 优化后的面包屑映射
export const routeBreadcrumbMap = {
  // 首页
  '/home': [COMMON_HOME],

  // ====================== 用户信息模块 ======================
  '/userHome': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/userHome', name: '用户管理' }
  ]),
  '/messagePage': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/messagePage', name: '消息列表' }
  ]),
  '/user/virtualUser': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/user/virtualUser', name: '虚拟用户' }
  ]),
  '/super/admin': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/super/admin', name: '超管列表' }
  ]),
  '/userRules': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/userRules', name: '用户认证' }
  ]),
  '/invitationPage': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/invitationPage', name: '邀请列表' }
  ]),
  '/appOnlineStats': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/appOnlineStats', name: '实时统计' }
  ]),
  '/banSpeak': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/banSpeak', name: '禁言列表' }
  ]),

  // 排行榜（优化动态路径处理）
  '/musterRanking': generateBreadcrumb([
    MODULE_MAP.USER_INFO,
    { path: '/musterRanking', name: '排行榜' },
    // 最后一级由页面根据 url 参数动态生成，这里只定义前两级
    { path: '/musterRanking', name: '动态排行' } 
  ]),

  '/square': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/square', name: '广场列表' }
  ]),
  '/circle': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/circle', name: '圈子列表' }
  ]),
  '/newCircle': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/newCircle', name: '新建圈子' }
  ]),
  '/editCircle': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/editCircle', name: '编辑圈子' }
  ]),
  '/adminCircle': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/adminCircle', name: '圈子管理员' }
  ]),
  '/examineCircle': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/examineCircle', name: '圈子创建审批' }
  ]),
  '/adminCheckCircle': generateBreadcrumb([ 
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/adminCheckCircle', name: '圈子申请门槛' }
  ]),
  '/subJect': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/subJect', name: '话题管理' }
  ]),
  '/artsBureau': generateBreadcrumb([
    MODULE_MAP.SQUARE_MANAGE,
    { path: '/artsBureau', name: '艺局管理' }
  ]),

  // ====================== 娱乐系统模块（修正模块路径） ======================
  '/tabgrade': generateBreadcrumb([
    { path: '/tabgrade', name: '娱乐系统' }, // 保持原路径兼容
    { path: '/tabgrade', name: '等级列表' }
  ]),
  '/decoration': generateBreadcrumb([
    { path: '/decoration', name: '娱乐系统' },
    { path: '/decoration', name: '积分商城' }
  ]),
  '/memberEdit': generateBreadcrumb([
    { path: '/memberEdit', name: '娱乐系统' },
    { path: '/memberEdit', name: '会员设置' }
  ]),
  '/giftManagement': generateBreadcrumb([
    { path: '/giftManagement', name: '娱乐系统' },
    { path: '/giftManagement', name: '礼物管理' }
  ]),
  '/userShare': generateBreadcrumb([
    { path: '/userShare', name: '娱乐系统' },
    { path: '/userShare', name: '分享配置' }
  ]),

  // ====================== 帖子管理模块 ======================
  '/anonymousCircle': generateBreadcrumb([
    MODULE_MAP.POST_MANAGE,
    { path: '/anonymousCircle', name: '小秘密列表' }
  ]),
  '/content': generateBreadcrumb([
    MODULE_MAP.POST_MANAGE,
    { path: '/content', name: '帖子列表' }
  ]),
  '/topContetn': generateBreadcrumb([ // 保留原拼写（建议后续修正为 topContent）
    MODULE_MAP.POST_MANAGE,
    { path: '/topContetn', name: '热门内容' }
  ]),
  '/contentIndtaID': generateBreadcrumb([ // 保留原拼写（建议后续修正为 contentDataID）
    MODULE_MAP.POST_MANAGE,
    { path: '/contentIndtaID', name: '帖子详情' }
  ]),
  '/replyContent': generateBreadcrumb([
    MODULE_MAP.POST_MANAGE,
    { path: '/replyContent', name: '评论列表' }
  ]),
  '/detailReplyContent': generateBreadcrumb([
    MODULE_MAP.POST_MANAGE,
    { path: '/detailReplyContent', name: '评论回复' }
  ]),
  '/replyContent/replyDetail': generateBreadcrumb([
    MODULE_MAP.POST_MANAGE,
    { path: '/replyContent/replyDetail', name: '评论详情' }
  ]),
  

  // ====================== 举报管理模块（优化动态路径） ======================
  '/cardReport': generateBreadcrumb([
    MODULE_MAP.REPORT_MANAGE,
    { path: '/cardReport', name: '举报类型选择' } // 父级页面
  ]),

  // ====================== 钱包管理模块 ======================
  '/runWallet': generateBreadcrumb([
    { path: '/runWallet', name: '钱包管理' }, // 保持原路径兼容
    { path: '/runWallet', name: '钱包充值设置' }
  ]),
  '/user/withdraw': generateBreadcrumb([
    { path: '/user/withdraw', name: '钱包管理' },
    { path: '/user/withdraw', name: '用户提现' }
  ]),
  '/giftRecord': generateBreadcrumb([
    { path: '/giftRecord', name: '钱包管理' },
    { path: '/giftRecord', name: '赠礼记录' }
  ]),

  // ====================== 用户服务模块（修复重复键问题） ======================
  '/serveContent': generateBreadcrumb([
    { path: '/serveContent', name: '用户服务' },
    { path: '/serveContent', name: '服务中心配置' }
  ]),
  '/adConfig': generateBreadcrumb([
    { path: '/adConfig', name: '用户服务' },
    { path: '/adConfig', name: '广告设置' }
  ]),
  '/taskCenterPage': generateBreadcrumb([
    { path: '/taskCenterPage', name: '用户服务' },
    { path: '/taskCenterPage', name: '任务中心' }
  ]),
  '/taskLog': generateBreadcrumb([
    { path: '/taskLog', name: '用户服务' },
    { path: '/taskLog', name: '任务完成记录' }
  ]),

  // ====================== 个人中心 ======================
  '/mymine': generateBreadcrumb([
    { path: '/mymine', name: '个人资料' }
  ]),
};

// 5. 动态面包屑生成工具函数（核心优化）
/**
 * 生成动态路径的面包屑
 * @param {string} basePath 基础路径（如 /cardReport、/musterRanking）
 * @param {string} type 参数值（如 0、post）
 * @param {Object} typeMap 类型映射表（如 reportTypeMap、rankTypeMap）
 * @param {string} middleName 中间级名称（如 举报管理、排行榜）
 * @returns {Array} 面包屑数组
 */
export const generateDynamicBreadcrumb = (basePath, type, typeMap, middleName = '') => {
  const breadcrumb = [...routeBreadcrumbMap[basePath]];
  // 替换最后一级为动态名称
  if (type && typeMap[type]) {
    breadcrumb[breadcrumb.length - 1] = {
      path: `${basePath}/${type}`,
      name: typeMap[type]
    };
    // 如果有中间级，插入到倒数第二级
    if (middleName) {
      breadcrumb.splice(-1, 0, { path: basePath, name: middleName });
    }
  }
  return breadcrumb;
};
